import { themeKey as s, themeLoadedKey as h } from "./injection-symbol.js";
import { StandardThemeDefinitions as d } from "./standard-theme-definitions.js";
class a {
  /**
   * The theme to use.
   */
  _Theme;
  /**
   * The theme definitions.
   */
  _Definitions;
  _ThemeLoaded;
  /**
   * Basic constructor for the theme plugin.
   *
   * @param options Options when creating the plugin.
   */
  constructor(e) {
    this._Definitions = e.themeDefinitions ?? new d(), this._Theme = this._Definitions.THEMES[e.name], this._ThemeLoaded = e.themeLoaded ?? [];
  }
  /**
   * Adds the relevant them CSS to the page.
   */
  async addCss() {
    const e = await this._Definitions.getCss(this._Theme.name), t = document.createElement("style");
    t.appendChild(document.createTextNode(e)), document.head.appendChild(t), this._ThemeLoaded.forEach((i) => i());
  }
  /**
   * Install the plugin to the provided vue application.
   *
   * @param app The vue application to install the app into.
   */
  async install(e) {
    e.provide(s, this._Theme), e.config.globalProperties.$theme = this._Theme, e.provide(h, this._ThemeLoaded), await this.addCss();
  }
}
export {
  a as ThemePlugin
};
//# sourceMappingURL=theme-plugin.js.map
